// import { Controller } from "@hotwired/stimulus"
// import intlTelInput from "intl-tel-input"
// import "intl-tel-input/build/css/intlTelInput.css"

// export default class extends Controller {
//   static targets = ['phone']

//   connect() {
//     const browserCountry =
//       (navigator.language || 'en').slice(-2).toLowerCase()

//     if (this.alreadyInitialized) return

//     this.alreadyInitialized = true
//     this.iti = intlTelInput(this.phoneTarget, {
//       initialCountry: browserCountry,
//       nationalMode: true,
//       separateDialCode: true,
//       onlyCountries: ['pl', 'no'],
//       hiddenInput: () => ({ phone: 'full_phone', country: 'country_code' }),
//       loadUtils: () => import('intl-tel-input/build/js/utils.js')
//     })
//   }

//   disconnect() {
//     if (this.iti) {
//       this.iti.destroy();
//       this.iti = null;
//     }
//   }
// }
import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"
import "intl-tel-input/build/css/intlTelInput.css"

export default class extends Controller {
  static targets = ['phone']

  connect() {
    if (this.alreadyInitialized) return

    this.alreadyInitialized = true

    this.iti = intlTelInput(this.phoneTarget, {
      initialCountry: this.getInitialCountry(),
      separateDialCode: true,
      nationalMode: true,
      onlyCountries: ['pl', 'no'],
      geoIpLookup: callback => {
        fetch("https://ipapi.co/json")
          .then(res => res.json())
          .then(data => {
            const countryCode = data?.country_code?.toLowerCase() || "pl"
            callback(countryCode)
          })
          .catch(() => callback("pl"))
      },
      hiddenInput: () => ({
        phone: 'full_phone',
        country: 'country_code'
      }),
      loadUtils: () => import('intl-tel-input/build/js/utils.js')
    })

    this.phoneTarget.addEventListener("countrychange", () => {
      const selected = this.iti.getSelectedCountryData()
      const d = new Date()
      d.setTime(d.getTime() + (1 * 60 * 60 * 1000))
      document.cookie = `country_code=${selected.iso2};expires=${d.toUTCString()};path=/;SameSite=Strict;`
    })

    // Remove border radius from right side of input when inside input-group
    const inputGroup = this.element.closest('.input-group')
    if (inputGroup) {
      this.phoneTarget.style.borderTopRightRadius = '0'
      this.phoneTarget.style.borderBottomRightRadius = '0'

      // Also remove border radius from left side of next button
      const button = inputGroup.querySelector('.btn-outline-danger')
      if (button) {
        button.style.borderTopLeftRadius = '0'
        button.style.borderBottomLeftRadius = '0'
      }
    }
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
      this.iti = null
    }
  }

  getInitialCountry() {
    const cookie = document.cookie
      .split("; ")
      .find(row => row.startsWith("country_code="))
      ?.split("=")[1]

    return cookie || "auto"
  }
}
